import { Visualization } from '@tapestry/types';
import { MeasureSlug } from '@tapestry/types';

export const ROW_HEIGHT = 106; //96 / 144

export const PHONE_LAYOUT = [
  { i: MeasureSlug.TotalSales, x: 0, y: 0, w: 1, h: 2 },
  { i: Visualization.TasksList, x: 0, y: 3, w: 2, h: 11 },
  { i: Visualization.TopProducts, x: 0, y: 15, w: 1, h: 5 },
];

export const TABLET_LAYOUT = [
  { i: Visualization.TasksList, x: 0, y: 0, w: 2, h: 9, minH: 9 },
  { i: MeasureSlug.TotalSales, x: 0, y: 13, w: 1, h: 2 },
  { i: Visualization.TopProducts, x: 1, y: 13, w: 1, h: 5 },
];

export const LAPTOP_LAYOUT = [
  { i: MeasureSlug.TotalSales, x: 0, y: 0, w: 1, h: 2 },
  { i: Visualization.TasksList, x: 1, y: 0, w: 2, h: 9 },
  { i: Visualization.TopProducts, x: 0, y: 1, w: 1, h: 5 },
];
